import { render, staticRenderFns } from "./OutreachClassList.vue?vue&type=template&id=4c30d2ae"
import script from "./OutreachClassList.vue?vue&type=script&lang=ts"
export * from "./OutreachClassList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports